function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.55,0A13.55,13.55,0,1,0,27.1,13.55,13.57,13.57,0,0,0,13.55,0ZM6.29,23.14A7.4,7.4,0,0,1,10,18.27a5.44,5.44,0,0,0,3.53,1.33,5.52,5.52,0,0,0,3.56-1.35,7.11,7.11,0,0,1,1.81,1.33,7.41,7.41,0,0,1,2,3.51,12,12,0,0,1-14.6.05Zm7.26-5c-2.46,0-4.45-2.36-4.45-5.25s2-5.25,4.45-5.25S18,10,18,12.85,16,18.1,13.55,18.1ZM22.15,22a9.3,9.3,0,0,0-4-4.88,7.3,7.3,0,0,0,1.33-4.25c0-3.72-2.67-6.75-5.95-6.75s-6,3-6,6.75A7.28,7.28,0,0,0,9,17.14,8.92,8.92,0,0,0,5,22.06,12,12,0,1,1,22.15,22Z"
});

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27.1,
    height: 27.1,
    viewBox: "0 0 27.1 27.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.07770999.svg";
export { ForwardRef as ReactComponent };